import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { parse } from 'date-fns';
import { AviaPassengerType, useMinPricesQuery } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { useConfig } from '../../../../../context';
import { API_DATE_FORMAT, useIsMobile } from '../../../../../utils';
import { getCurrencyFromOrder } from '../../../../../Checkout/store/order/selectors';
import { subsHalfCalendarDaysCount } from '../../../../../Results/components/Results/utils';
import WeekCalendar from '../../../../../Results/components/Results/Calendar/WeekCalendar/WeekCalendar';
import { ExchangeRefundContentWrapper } from '@entities/order';
import { fetchExchangeVariants, getSelectedFlightsCount, getSearchParameters, getSelectedSegmentOnLeg, getSelectedSegmentMinDate, getExchangeVariantsParams } from '@entities/exchange';
import { SelectSegmentDate, useSelectSegmentDate } from '@features/exchange/select-date';
import { RemoveLastSelectedFlightButton } from '@features/exchange/remove-selected-flight';
import { ContentWithSelectedFlights } from '../ContentWithSelectedFlights';
import { SearchFlights } from '../SearchFlights';
const Flights = () => {
    var _a, _b, _c;
    const { t } = useTranslation('Exchange');
    const { Flights: theme } = useTheme('Widgets').Exchange;
    const dispatch = useDispatch();
    const orderCurrency = useSelector(getCurrencyFromOrder);
    const selectedFlightsCount = useSelector(getSelectedFlightsCount);
    const searchParams = useSelector(getSearchParameters);
    const selectedSegment = useSelector(getSelectedSegmentOnLeg);
    const selectedSegmentMinDate = useSelector(getSelectedSegmentMinDate);
    const exchangeVariantsParams = useSelector(getExchangeVariantsParams);
    const isMobile = useIsMobile();
    const calendarDaysCount = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.Engine.calendarDaysCount;
    const { data: minPrices } = useMinPricesQuery({
        variables: {
            params: Object.assign(Object.assign({}, searchParams), { passengers: searchParams.passengers.filter(passenger => [
                    AviaPassengerType.ADT,
                    AviaPassengerType.CLD,
                    AviaPassengerType.INF,
                    AviaPassengerType.INS
                ].includes(passenger.passengerType)), segments: searchParams.segments.map(segment => subsHalfCalendarDaysCount(segment, calendarDaysCount)), daysCount: calendarDaysCount })
        },
        context: { currency: orderCurrency },
        skip: isMobile
    });
    useEffect(() => {
        dispatch(fetchExchangeVariants());
    }, [exchangeVariantsParams]);
    const { onSetSegmentDate } = useSelectSegmentDate();
    const onChangeDateHandler = useCallback((searchParams) => {
        const newDate = parse(searchParams.segments[selectedFlightsCount].date, API_DATE_FORMAT, new Date());
        onSetSegmentDate(selectedSegment.id, newDate);
    }, [selectedSegment.id]);
    const selectSegmentDateControl = React.createElement(SelectSegmentDate, { segmentId: selectedSegment.id });
    return (React.createElement(ContentWithSelectedFlights, { controls: React.createElement(RemoveLastSelectedFlightButton, { label: t('Flights.ChangeFlight') }) },
        React.createElement(ExchangeRefundContentWrapper, { icon: selectedFlightsCount + 1, title: React.createElement("span", { className: theme.title, dangerouslySetInnerHTML: {
                    __html: t('Flights.Title', {
                        departure: selectedSegment.departure.cityName,
                        arrival: selectedSegment.arrival.cityName
                    })
                } }), controls: !isMobile && selectSegmentDateControl },
            !isMobile && (React.createElement(WeekCalendar, { legId: selectedFlightsCount, alternativePrices: (_c = (_b = minPrices === null || minPrices === void 0 ? void 0 : minPrices.FlightsMinPricesInPeriod) === null || _b === void 0 ? void 0 : _b.datesWithLowestPrices) !== null && _c !== void 0 ? _c : [], searchParameters: searchParams, minDate: selectedSegmentMinDate, hidePrice: false, startNewSearch: onChangeDateHandler })),
            React.createElement(SearchFlights, { key: selectedFlightsCount, controls: isMobile && selectSegmentDateControl }))));
};
export default Flights;
